var render, staticRenderFns
import script from "./TCol.vue?vue&type=script&lang=js"
export * from "./TCol.vue?vue&type=script&lang=js"
import style0 from "./TCol.vue?vue&type=style&index=0&id=cc702938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports